/**
 * @fileoverview gRPC-Web generated client stub for InkCapture
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.6
// source: icws_proto/icws_api_gateway/updating.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as icws_proto_icws_api_gateway_updating_update_processed_scan_pb from '../../icws_proto/icws_api_gateway/updating/update_processed_scan_pb';


export class UpdatingClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorUpdateProcessedScan = new grpcWeb.MethodDescriptor(
    '/InkCapture.Updating/UpdateProcessedScan',
    grpcWeb.MethodType.UNARY,
    icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanRequest,
    icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse,
    (request: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanRequest) => {
      return request.serializeBinary();
    },
    icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse.deserializeBinary
  );

  updateProcessedScan(
    request: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanRequest,
    metadata: grpcWeb.Metadata | null): Promise<icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse>;

  updateProcessedScan(
    request: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse) => void): grpcWeb.ClientReadableStream<icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse>;

  updateProcessedScan(
    request: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icws_proto_icws_api_gateway_updating_update_processed_scan_pb.UpdateProcessedScanResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/InkCapture.Updating/UpdateProcessedScan',
        request,
        metadata || {},
        this.methodDescriptorUpdateProcessedScan,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/InkCapture.Updating/UpdateProcessedScan',
    request,
    metadata || {},
    this.methodDescriptorUpdateProcessedScan);
  }

}

